import { useContext, useState } from "react";
import { useNavigate } from "react-router";

import { routes } from "~/app/routes/web-routes.ts";
import { QuoteDetailsContext } from "~/features/quote/context/quote-details-context.tsx";
import type { CarrierPrice } from "~/shared/schemas/carrier-schema.ts";

import { getEffectiveCarrierLiability } from "../../../utils/carrier-liability.ts";

type UseCarrierCardActionParams = {
	carrierPrice: CarrierPrice;
	onSelectCarrier?: (carrier: CarrierPrice) => void;
	isReratePrevCarrier?: boolean;
	poNumber: number | null;
	enableShipmentValueModal: boolean;
	handleBookCarrierClick: () => void;
};

export const useCarrierCardAction = ({
	carrierPrice,
	onSelectCarrier,
	isReratePrevCarrier,
	poNumber,
	enableShipmentValueModal,
	handleBookCarrierClick,
}: UseCarrierCardActionParams) => {
	const navigate = useNavigate();
	const { quoteState } = useContext(QuoteDetailsContext);
	const [showLoadValueModal, setShowLoadValueModal] = useState(false);
	const [isInsuranceAddedLocally, setIsInsuranceAddedLocally] = useState(false);

	const handleAction = () => {
		if (onSelectCarrier) {
			onSelectCarrier(carrierPrice);
			return;
		}
		if (isReratePrevCarrier) {
			navigate(
				poNumber == null
					? routes.track
					: routes.shipmentManagement.replace(":poNumber", String(poNumber)),
			);
			return;
		}
		if (
			enableShipmentValueModal &&
			(quoteState.insuranceApplyTypeId == null || isInsuranceAddedLocally) &&
			quoteState.insuranceValue !== null &&
			quoteState.insuranceValue > 0 &&
			quoteState.insuranceValue >
				getEffectiveCarrierLiability(
					carrierPrice,
					quoteState.insuranceProductTypeId,
				)
		) {
			setShowLoadValueModal(true);
			return;
		}
		handleBookCarrierClick();
	};

	const handleLoadValueModalClose = () => setShowLoadValueModal(false);
	const handleLoadValueModalAccept = () => {
		setShowLoadValueModal(false);
		handleBookCarrierClick();
	};
	const handleInsuranceAdded = () => setIsInsuranceAddedLocally(true);

	return {
		handleAction,
		showLoadValueModal,
		handleLoadValueModalClose,
		handleLoadValueModalAccept,
		handleInsuranceAdded,
	};
};
